import { Modal, Input } from "antd";
import { LockOutlined } from "@ant-design/icons";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { posModalStyles as modalStyles } from "./modalPrimitives";
import { useViewport } from "../../../hooks/useViewport";
import { R } from "./orderingTheme";
import {
  ModalHeader,
  ModalFooter,
  GhostButton,
  PrimaryButton,
} from "./modalPrimitives";

interface LogoutConfirmModalProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: (password: string) => Promise<void>;
  loading?: boolean;
}

export default function LogoutConfirmModal({
  open,
  onCancel,
  onConfirm,
  loading = false,
}: LogoutConfirmModalProps) {
  const { t } = useTranslation();
  const { isMobile, isNarrow, isTablet } = useViewport();
  const [password, setPassword] = useState("");

  const handleConfirm = async () => {
    await onConfirm(password);
    setPassword("");
  };

  const handleCancel = () => {
    setPassword("");
    onCancel();
  };

  const width = isMobile ? undefined : isTablet ? 420 : 460;
  const bodyPad = isNarrow ? "16px" : "20px 24px";

  return (
    <Modal
      open={open}
      onCancel={handleCancel}
      footer={null}
      centered
      closable={false}
      destroyOnHidden
      width={width}
      styles={modalStyles}
      style={{ maxWidth: "calc(100vw - 32px)" }}
    >
      <div
        style={{ background: R.surface, fontFamily: R.font, color: R.text }}
      >
        <ModalHeader
          icon={<LockOutlined />}
          title={t("logoutConfirm.title")}
          subtitle={t("logoutConfirm.subtitle")}
          onClose={handleCancel}
          isNarrow={isNarrow}
        />

        <div style={{ padding: bodyPad }}>
          <Input.Password
            placeholder={t("logoutConfirm.passwordPlaceholder")}
            prefix={<LockOutlined style={{ color: R.textMuted }} />}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onPressEnter={handleConfirm}
            autoFocus
            style={{
              height: 44,
              borderRadius: 10,
              borderColor: R.border,
            }}
          />
        </div>

        <ModalFooter isNarrow={isNarrow}>
          <GhostButton
            label={t("common.cancel")}
            onClick={handleCancel}
            disabled={loading}
          />
          <PrimaryButton
            label={t("common.confirm")}
            onClick={handleConfirm}
            disabled={!password.trim()}
            loading={loading}
          />
        </ModalFooter>
      </div>
    </Modal>
  );
}
